import { Component, OnInit } from '@angular/core';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-rt-origin-idle-days-report',
    templateUrl: './rt-origin-idle-days-report.component.html',
    styleUrls: ['./rt-origin-idle-days-report.component.css'],
})
export class RtOriginIdleDaysReportComponent implements OnInit {
    public gridId = 127;

    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Origin Idle Days Report';
    public gridSource: any;

    public displayReport: boolean = false;
    public controlNames: string[] = ['Trip Close Begin Date', 'Trip Close End Date'];

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit() {
        this.pageService.setHeader(this.pageHeader);
    }

    onGetReportClick(event: any) {
        this.displayReport = true;
        this.gridSource = this.reportService.CreateAspNetDatastore(
            ReportConstants.ReportDataApiCall,
            this.gridId.toString(),
            event.startDate,
            event.endDate,
        );
    }

    onCancelClick() {
        this.displayReport = false;
    }
}
